import { ProductionDashboard } from "./components/dashboard/ProductionDashboard";
import { SelectedDivisionProvider } from "./context/DivisionContext";

const Production = () => {
  return (
    <SelectedDivisionProvider>
      <ProductionDashboard />
    </SelectedDivisionProvider>
  );
};

export { Production };
